import api from "../../../services/api";

export const getWholesaleCustomerSegmentation = async () => {
  const response = await api.get("/api/wholesale/customer_insights/customer_segmentation");
  const raw = response.data.customer_segmentation;

  return Object.entries(raw).map(([key, value]: [string, any]) => ({
    segment: key
      .replace(/_/g, " ")
      .replace("last year", "")
      .trim()
      .replace(/\b\w/g, l => l.toUpperCase()),
    count: value.customers,
    percentage: value.percentage,
    avgOrderValue: value.avg_order_value,
    purchaseFrequency: value.purchase_frequency,
    status: value.status,
  }));
};
